import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import styled, { keyframes } from 'styled-components';
import { useAuthStore } from '@/store/useAuthStore';
import GlobalStyles from '@/styles/GlobalStyles';
import LoadingSpinner from '@/shared/components/molecules/Loader';
import { router } from './routes/Route';

if (process.env.NODE_ENV === 'production') {
	console.log = function no_console() {};
	console.warn = function no_console() {};
	console.info = function no_console() {};
}

// 세션 복원이 금방 끝나면 로딩 화면이 깜빡이지 않도록 이 시간이 지난 뒤부터 서서히 노출
const LOADING_APPEAR_DELAY_MS = 300;

const App = () => {
	const isLoading = useAuthStore(state => state.isLoading);

	return (
		<>
			<GlobalStyles />
			<ToastContainer autoClose={2000} />
			{/* 라우트 가드가 복원된 로그인 상태로만 판단하도록 복원이 끝난 뒤 라우터를 띄운다 */}
			{isLoading ? (
				<LoadingScreen>
					<LoadingSpinner />
				</LoadingScreen>
			) : (
				<RouterProvider router={router} />
			)}
		</>
	);
};

export default App;

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const LoadingScreen = styled.div`
	height: 100vh;
	opacity: 0;
	animation: ${fadeIn} 0.2s ease-in ${LOADING_APPEAR_DELAY_MS}ms forwards;
`;
